import React, { createContext, useContext, useState, useEffect } from 'react';
import ConnectivityService from '../services/ConnectivityService';

interface NetworkStatusContextType {
    isOnline: boolean;
}

const NetworkStatusContext = createContext<NetworkStatusContextType>({ isOnline: true });

export const useNetworkStatus = () => useContext(NetworkStatusContext);

export const NetworkStatusProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [isOnline, setIsOnline] = useState(ConnectivityService.isOnline);

    useEffect(() => {
        const listener = (online: boolean) => setIsOnline(online);
        ConnectivityService.subscribe(listener);
        ConnectivityService.startHealthCheck(process.env.REACT_APP_API_URL || '');
        return () => {
            ConnectivityService.unsubscribe(listener);
            ConnectivityService.stopHealthCheck();
        };
    }, []);

    return (
        <NetworkStatusContext.Provider value={{ isOnline }}>
            {children}
        </NetworkStatusContext.Provider>
    );
};
